import { HttpMethods, makeRequest } from '../helpers/http.helper';
import type {
  CarbonAvoidanceReportParams,
  GenericResponse,
  OrganizationCarbonAvoidanceReport,
} from '../types/carbon-avoidance-report.type';

function basePath(organizationId: string): string {
  return `/esg/organizations/${organizationId}/carbon-avoidance-report`;
}

export async function getCarbonAvoidanceReport(
  organizationId: string,
  params: CarbonAvoidanceReportParams
): Promise<OrganizationCarbonAvoidanceReport> {
  const raw = await makeRequest({
    url: basePath(organizationId),
    method: HttpMethods.GET,
    params,
  });
  const data = raw as GenericResponse<OrganizationCarbonAvoidanceReport>;
  if (!data?.result) {
    throw new Error('Invalid carbon avoidance report response');
  }
  return data.result;
}
